import { createSelector } from 'reselect';

import { getBodyData } from 'store/selectors';
import { REQUEST_ERROR, REQUEST_SUCCESS } from 'store/constants';

import { getFancyNumbersStatus } from '../selectors';
import { BUNDLE_TYPE_FANCY } from './constants';

export class BundleProduct {
  constructor(value) {
    this.state = {
      ...value,
      price: value.price || {},
    };
  }

  getSlug = () => this.state.slug;

  getTitle = () => this.state.title;

  getTooltip = () => this.state.tooltip;

  getThumbUrl = () => this.state.thumbUrl;

  getPrice = () => this.state.price.value;

  getOldPrice = () => this.state.price.oldValue;
}

export class Bundle {
  constructor(value) {
    this.state = {
      ...value,
      products: (value.products || []).map((data) => new BundleProduct(data)),
    };
  }

  getPrice = () => this.state.price;

  getOldBundlePrice = () => this.state?.priceWithoutPromotion;

  getDiscount = () => this.state.discount;

  getDiscountPercent = () => this.state?.discountPercent;

  getSlug = () => this.state.slug;

  getPromotionId = () => this.state.promotionId;

  getTariffDpcId = () => this.state.dpcId;

  getBundleProducts = () => this.state.products;

  getActionData = () => ({
    slug: this.getSlug(),
    promotionId: this.getPromotionId(),
    dpcId: this.getTariffDpcId(),
  });
}

export const getBundleData = (state) => getBodyData(state).bundles || {};
const getBundlePromotion = (state) => getBodyData(state).promotion || {};
export const getBundleLinkText = (state) => getBundlePromotion(state).linkText || '';
export const getBundlesHeadline = (state) => getBundleData(state).headline;
export const getEsim = (state) => getBodyData(state).esim || {};
export const getHasEsim = (state) => getEsim(state).hasESim;
export const getBundlesListRaw = (state) => getBundleData(state).list || [];
export const getBundlesListModel = createSelector(
  getBundlesListRaw,
  getFancyNumbersStatus,
  (list, fancyNumbersStatus) =>
    list
      .map((item) => new Bundle(item))
      .filter(
        (item) => fancyNumbersStatus !== REQUEST_ERROR || item.getSlug() !== BUNDLE_TYPE_FANCY,
      ),
);

export const getBundlesButtonText = (state) => getBundleData(state).buttonText;
export const getBundlesFullPriceText = (state) => getBundleData(state).fullPriceText;
export const getBundlesDiscountText = (state) => getBundleData(state).discountText;
export const getBundlesPriceWithoutPromotion = (state) =>
  getBundleData(state).priceWithoutPromotion;
export const getBundlesDiscountPercent = (state) => getBundleData(state).discountPercent;
export const getBundleAvailability = (state) =>
  !!getBodyData(state).bundles && !!getBundlesListModel(state).length;

/* selectors special for preorder */
export const getPreorderBundlePromotionId = (state) =>
  getBundlesListModel(state)[0].getPromotionId();

export const composeIsBundleReady =
  (state) =>
  ({ slug }) => {
    const fancyNumberReady = getFancyNumbersStatus(state) === REQUEST_SUCCESS;
    return slug !== BUNDLE_TYPE_FANCY || fancyNumberReady;
  };
